import { useCallback, useRef, useState, useEffect } from "react";
import { Space, Input, Select, Button, Modal,message } from "antd";
import "../moduleRoleAdd/index.styl";
import {
  getMainModuleList,
  getChildModuleList,
  getRoleList,
} from "../../../api/common";
import { addDepart } from "../../../api/departmentJob";

const { TextArea } = Input;

export default function ModuleDepartAdd() {


  //操作分类
  //const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultActionModuleKey, setdefaultActionModuleKey] = useState(1);//默认添加新手村

  // 主模块
  const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultMainModuleKey, setDefaultMainModuleKey] = useState(0);
  //const [defaultMainModuleName, setDefaultMainModuleName] = useState("");
  const [defaultMainModuleVisible, setDefaultMainModuleVisible,] = useState(true);
  const [mainDisabled, setMainDisabled,] = useState(true);


  // 子模块
  const [childModuleData, setChildModuleData] = useState([]);
  const [defaultChildModuleKey, setDefaultChildModuleKey] = useState(0);
  //const [defaultChildModuleName, setDefaultChildModuleName] = useState("");
  const [defaultChildModuleVisible, setDefaultChildModuleVisible,] = useState(true);
  const [childDisabled, setChildDisabled,] = useState(true);

  //部门名称
  const [departName, setdepartName] = useState('');
  const [departNameLeble, setdepartNameLeble] = useState('自然村名');

  //自然村
  // const [countrysideData, setCountrysideData] = useState([]);
  // const [defaultCountrysideKey, setDefaultCountrysideKey] = useState("");


  // 获取主模块数据,子模块数据
  useEffect(() => {
    async function fetchDataList() {
      loadMainData(9);//默认选择新手村
      loadChildData(9,11);//默认自然村    
    }
    fetchDataList();
  }, []);

  //加载主板数据
const loadMainData=async (defaultId) => {
  const mainModuleList = [{ id: 0, name: "请选择" }];
  const res = await getMainModuleList();
  if (res?.code == 0 && res?.data?.length > 0) {
    mainModuleList.push(...res.data);
  }
  setMainModuleData(mainModuleList);
  setDefaultMainModuleKey(defaultId);//选中项
}
 //加载子板数据
 const loadChildData=async (mainId,defaultId) => {
  const childModuleData = [];
  let id = mainId;
  const r = await getChildModuleList({ main_depart_id: id });
  if (r.code == 0 && r.data?.length > 0) {
    childModuleData.push(...r.data);
  }
  setChildModuleData(childModuleData);
  setDefaultChildModuleKey(defaultId);
}

  // 选择操作
  const onActionModuleItemSelected = async (id, option) => {
    setdefaultActionModuleKey(id);

    //显示隐藏逻辑
    if (id == 1) {

      //主版块显示,同时设置为新手村
      setDefaultMainModuleVisible(true);
      loadMainData(9);//默认选择新手村

      //子版块显示,同时设置为自然村
      setDefaultChildModuleVisible(true);
      loadChildData(9,11);//默认自然村 
      setdepartNameLeble('自然村名');

      setChildDisabled(true);
      setMainDisabled(true);
    } else if (id == 2) {
      loadMainData(0);
      setDefaultMainModuleVisible(true);
      setDefaultChildModuleVisible(false);
      setdepartNameLeble('子板块名');

      setChildDisabled(true);
      setMainDisabled(false);

    } else if (id == 3) {
      setDefaultMainModuleVisible(false);
      setDefaultChildModuleVisible(false);
      setdepartNameLeble('主板块名');

      setChildDisabled(true);
      setMainDisabled(true);

    }
  };




  // const clearValue = function () {
  //   setdescription('');
  //   setbeanAmount('');
  //   setpaymentFrequency(-1);
  //   setjobName('');
  // }

  const addDepart_click = async () => {
    
    let op = defaultActionModuleKey;
    let data = {
      level: 2,
      name: departName,
      parent_id: 11
    };
    
    if(op == 1){
      data.parent_id = 11; 
    }else if(op == 2){//添加子板块
      data.parent_id = defaultMainModuleKey; 
    }else if(op == 3){//添加主板块
      data.parent_id = 0;
      data.level = 1;
    }    
    const res = await addDepart(data);
    if(res.code == 0){
      message.success("添加成功！");
    }else{
      //message.warning("");
      message.error("添加失败,请检查是否重名");   
    }
  };

  const onDepartNameChanged = (e) => {
    setdepartName(e.target.value);
  }

  // 选择主模块item
  const onMainModuleItemSelected = async (id, option) => {
    setDefaultMainModuleKey(id);
  };


  // 选择子模块
  const onChildModuleItemSelected = async (id, option) => {
  };

  const onCreateClick = () => {
    addDepart_click();
  };

  return (
    <div className="roleAddPage">
      <Space
        direction='vertical'
        align='start'
        size='middle'
      >
        <Space>
          <span className="leftTitle">请选择操作：</span>
          <Select
            value={defaultActionModuleKey}
            style={{ width: 180 }}
            fieldNames={{ label: "name", value: "id" }}
            onChange={onActionModuleItemSelected}
            options={[
              { id: 1, name: "添加新手村" },
              { id: 2, name: "添加子版块" },
              { id: 3, name: "添加主版块" }
            ]}
          />
        </Space>
        {defaultMainModuleVisible ? (
          <Space>
            <span className="leftTitle">请选择板块：</span>
            <Select
              value={defaultMainModuleKey}
              style={{ width: 180 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onMainModuleItemSelected}
              options={mainModuleData}
              disabled={mainDisabled}
            />
          </Space>
        ) : null}

        {defaultChildModuleVisible ? (
          <Space>
            <span className="leftTitle">选择子板块：</span>
            <Select
              value={defaultChildModuleKey}
              style={{ width: 180 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onChildModuleItemSelected}
              options={childModuleData}
              disabled={childDisabled}
            />
          </Space>
        ) : null}

        <Space>
          <span className="leftTitle">&nbsp;&nbsp;&nbsp;{departNameLeble}：</span>
          <Input
            style={{
              width: 180,
            }}
            onChange={onDepartNameChanged}
            placeholder="请输入名称"
            value={departName}
          />
        </Space>



        <div className="createButton">
          <Button
            type="primary"
            style={{ width: 160, }}
            onClick={onCreateClick}
          >创建
          </Button>
        </div>
      </Space>
      {/* <Modal title="创建岗位角色"
        open={isModalOpen}
        onOk={addJob}
        onCancel={handleCancel}
        cancelText='取消'
        okText='确定'
      >
        <p>板块：{defaultMainModuleName}</p>
        <p>子版块：{defaultChildModuleName}</p>
        <p>任务角色：{jobName}</p>
        <p>岗位标准：每{paymentFrequency == 0 ? '次' : '月'}{beanAmount}个智慧豆</p>
        <p>岗位介绍：{description}</p>
      </Modal> */}
    </div>
  );
}
